/**
 * saveTimer.js — measures how long each step of a save takes (2026-09-30).
 *
 * Every save logs ONE line to the browser console, e.g.
 *   [save-timer] Create SI-2526-00012 — 1840 ms | checks+number 620 | parent 0 | build rows 35 | write to server 410 | after-save steps 775
 *
 * To see the last 30 saves as a table: open the browser console (F12) and type
 *   amalSaveLog()
 * Nothing is sent anywhere and nothing is written to the database — it only
 * reads the clock, so it has no cost.
 */
const MAX_ENTRIES = 30;
const log = [];

const now = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now());

export const startSaveTimer = (label) => {
  const t0 = now();
  let last = t0;
  const steps = [];
  let ended = false;
  return {
    /** Close the current step (time since the previous step). */
    step(name) {
      const t = now();
      steps.push({ step: name, ms: Math.round(t - last) });
      last = t;
    },
    /** Record a step measured elsewhere (e.g. one of several parallel reads). */
    add(name, ms) { steps.push({ step: name, ms: Math.round(ms) }); },
    setLabel(l) { label = l; },
    end(status = 'ok') {
      if (ended) return;
      ended = true;
      const total = Math.round(now() - t0);
      const entry = { at: new Date().toLocaleTimeString(), label, total, status, steps };
      log.push(entry);
      if (log.length > MAX_ENTRIES) log.shift();
      try {
        const parts = steps.map(s => `${s.step} ${s.ms}`).join(' | ');
        // eslint-disable-next-line no-console
        console.info(`[save-timer] ${label} — ${total} ms${status !== 'ok' ? ` (${status})` : ''}${parts ? ` | ${parts}` : ''}`);
      } catch (e) { /* never break a save */ }
    },
  };
};

/** Wrap a promise so its own duration is recorded (for steps run in parallel). */
export const timed = (timer, name, promise) => {
  if (!timer) return promise;
  const t = now();
  return Promise.resolve(promise).finally(() => timer.add(`  · ${name}`, now() - t));
};

if (typeof window !== 'undefined') {
  window.amalSaveLog = () => {
    const rows = [];
    log.forEach(e => {
      rows.push({ time: e.at, save: e.label, ms: e.total, step: '— TOTAL —' });
      e.steps.forEach(s => rows.push({ time: '', save: '', ms: s.ms, step: s.step }));
    });
    // eslint-disable-next-line no-console
    console.table(rows);
    return `${log.length} saves shown`;
  };
}
